export const LOGIN_PATIENT_SUCCESS = 'LOGIN_PATIENT_SUCCESS'
export const LOGIN_DOCTOR_SUCCESS = 'LOGIN_DOCTOR_SUCCESS'
export const LOGIN_HOSPITAL_SUCCESS = 'LOGIN_HOSPITAL_SUCCESS'
export const REGISTER_PATIENT_SUCCESS = 'REGISTER_PATIENT_SUCCESS'
export const REGISTER_DOCTOR_SUCCESS = 'REGISTER_DOCTOR_SUCCESS'
export const REGISTER_HOSPITAL_SUCCESS = 'REGISTER_HOSPITAL_SUCCESS'
export const LOGIN_PATIENT_ERROR = 'LOGIN_PATIENT_FAIL'
export const LOGIN_DOCTOR_ERROR = 'LOGIN_DOCTOR_FAIL'
export const LOGIN_HOSPITAL_ERROR = 'LOGIN_HOSPITAL_FAIL'
export const REGISTER_PATIENT_ERROR = 'REGISTER_PATIENT_FAIL'
export const REGISTER_DOCTOR_ERROR = 'REGISTER_DOCTOR_FAIL'
export const REGISTER_HOSPITAL_ERROR = 'REGISTER_HOSPITAL_FAIL'
export const AUTH_ERROR = 'AUTH_ERROR'
export const SET_LOADING = 'SET_LOADING'
export const LOGOUT = 'LOGOUT'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const PATIENT_UPDATE = 'PATIENT_UPDATE'
export const DOCTOR_UPDATE = 'DOCTOR_UPDATE'
export const HOSPITAL_UPDATE = 'HOSPITAL_UPDATE'
export const PATIENT_UPDATE_ERROR = 'PATIENT_UPDATE_ERROR'
export const DOCTOR_UPDATE_ERROR = 'DOCTOR_UPDATE_ERROR'
export const HOSPITAL_UPDATE_ERROR = 'HOSPITAL_UPDATE_ERROR'
export const GET_STATES = 'GET_STATES'
export const GET_STATE = 'GET_STATE'
export const STATE_ERROR = 'STATE_ERROR'
export const SET_CURRENT = 'SET_CURRENT'
export const CLEAR_CURRENT = 'CLEAR_CURRENT'
export const GET_LGAS = 'GET_LGAS'
export const LGA_ERROR = 'LGA_ERROR'
export const GET_PATIENT = 'GET_PATIENT'
export const PATIENT_ERROR = 'PATIENT_ERROR'
export const GET_ECARD = 'GET_ECARD'
export const ADD_ECARD = 'ADD_ECARD'
export const GET_APPOINTMENTS = 'GET_APPOINTMENTS'
export const ECARD_ERROR = 'ECARD_ERROR'
export const APPOINTMENTS_ERROR = 'APPOINTMENTS_ERROR'
